<ng-container class="db-remove-wrap">
  <div class="db-remove-website__url mb15">
    <i class="db-icon db-icon-ds-domains"></i> {{website?.site_url}}
  </div>

  <h2 class="db-remove-website__title mb10">
    {{ (!website?.isNetwork || isSubSite) ? ('text_removeDemoWebsite' | dbText) : ('text_removeMultisite' | dbText) }}
  </h2>

  <p *ngIf="website?.domain_hash" class="db-remove-website__text mb20">
    {{ 'text_hostedWebsiteAfterRemoveWillLost' | dbText }}
  </p>

  <ng-container *ngIf="!website.domain_hash">
    <p *ngIf="connectedFrom !== 'speed_optimizer' && connectedFrom !== 'image_optimizer'" class="db-remove-website__text mb20">
      {{ 'text_areYouSureToRemove1' | dbText }}</p>

    <p *ngIf="connectedFrom === 'speed_optimizer'" class="db-remove-website__text mb20" [innerHTML]="'text_removeSpeedWebsiteDesc' | dbText">
    </p>

    <p *ngIf="connectedFrom === 'speed_optimizer'"
       class="db-remove-website__text mb15">{{ 'text_removeSpeedWebsiteListTitle' | dbText }}</p>

    <p *ngIf="connectedFrom === 'image_optimizer'"
       class="db-remove-website__text mb15">{{ 'text_removeImageOptimizerListTitle' | dbText }}</p>
  </ng-container>


  <ul class="db-remove-website__list">
    <li *ngFor="let feature of features">
      <i class="db-icon db-icon-ds-close-bg"></i>{{ feature | dbText }}
    </li>
  </ul>

  <div *ngIf="website?.cloudflareEnabled" class="ds-notification-error mt16">
    <div>
      <i class="db-icon db-icon-ds-close-bg"></i>
      <p>
        Cloudflare Enterprise integration will be disabled. Revert your DNS records back to original<br>
        server IP and make sure everything is resolved, otherwise your website will be down.
      </p>
    </div>
  </div>

  <form [formGroup]="removeWebsiteForm" (ngSubmit)="remove()">
    <div *ngIf="!isFreePlan && !isSubSite; else typeRemove" class="ds-input-wrap mt20 mb9">
      <span class="ds-input-label">{{ (!website?.isNetwork || isSubSite) ? ('text_typeRemoveWebsite' | dbText) : ('text_typeRemoveMultiWebsite' | dbText) }}</span>
      <div class="ds-input-password-wrap">
        <input #password type="password" class="ds-input" [placeholder]="'text_createProfilePassword' | dbText" formControlName="password"
               [ngClass]="{'error': formSubmitted && removeWebsiteForm?.get('password')?.errors}">
        <a class="ds-input-password-trigger" (click)="password.type = password.type === 'text' ? 'password' : 'text'; password.focus()">
          <i class="db-icon {{password.type === 'text' ? 'db-icon-ds-eye' : 'db-icon-ds-eye-cancel'}}"></i>
        </a>
      </div>
      <span *ngIf="formSubmitted && removeWebsiteForm?.get('password')?.errors" class="ds-input-error-msg"
            [innerHTML]="removeWebsiteForm?.get('password')?.errors['required'] ? ('text_fillFnField' | dbText)
          : removeWebsiteForm?.get('password')?.errors?.server ? removeWebsiteForm?.get('password')?.errors?.server : ''">
    </span>
    </div>

    <ng-template #typeRemove>
      <div class="ds-input-wrap mt20 mb9">
        <span class="ds-input-label">{{ 'text_removeConfirmationText' | dbText }}</span>
        <input type="text" class="ds-input" [placeholder]="'text_typeRemovePlaceholder' | dbText" formControlName="password"
               [ngClass]="{'error': formSubmitted && removeWebsiteForm?.get('password')?.errors}">
        <span *ngIf="formSubmitted && removeWebsiteForm?.get('password')?.errors" class="ds-input-error-msg"
              [innerHTML]="removeWebsiteForm?.get('password')?.errors['required'] ? ('text_fillFnField' | dbText) : ''">
    </span>
      </div>
    </ng-template>


    <div class="text-right">
      <button class="ds-btn mr20" [ngClass]="{'ds-btn-disabled': loading, 'ds-btn-small': isMobile}"
              type="button" (click)="close()">
        <span [innerHTML]="!this.website.domain_hash && !isSubSite ? ('text_stayConnected' | dbText) : ('text_cancel' | dbText)"></span>
      </button>
      <button class="ds-btn-red" [ngClass]="{'ds-btn-disabled': removeWebsiteForm.invalid || loading, 'ds-btn-small': isMobile}" type="submit">
        <span *ngIf="!loading">{{ 'text_removeDemoWebsiteBtn' | dbText }}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
    </div>
  </form>
</ng-container>
